export enum AssemblyType {
    PRODUCT = "product",
    ASSEMBLY = "assembly",
    SUB_ASSEMBLY = "sub_assembly",
    COMPONENTS = "components",
    FUNCTIONAL_BREAKDOWN = "breakdown",
    SUBSYSTEM = "subsytem",
    MODULE = "module",
    PART = "part",
    SUPPLIERS = "suppliers",
}
